import ScrollReveal from "./ScrollReveal";

export default function TechStack() {
  const stacks = [
    "PostgreSQL",
    "REST APIs",
    "Django / Node.js",
    "Docker",
    "System Architecture",
    "Performance Optimization",
    "Database Design",
    "Clean Backend Engineering",
  ];

  return (
    <section className="relative py-32 bg-slate-50 overflow-hidden">

      {/* Subtle Atmospheric Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-gradient-to-r from-blue-200/20 via-blue-100/10 to-transparent blur-3xl"></div>

      <ScrollReveal>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">

          {/* Header */}
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-widest text-blue-600 font-semibold mb-4">
              Expertise
            </p>

            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
              Technologies & Systems
            </h2>

            <p className="text-lg text-slate-600 mt-4 max-w-2xl mx-auto leading-relaxed">
              I build scalable backend systems focused on reliability, performance,
              and clean architectural design.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stacks.map((stack) => (
              <div
                key={stack}
                className="
                  group
                  bg-white/90 backdrop-blur-sm
                  border border-slate-200
                  rounded-2xl
                  p-6
                  text-center
                  shadow-sm
                  transition duration-300
                  hover:-translate-y-1
                  hover:shadow-xl
                  hover:shadow-blue-100/40
                  hover:border-blue-500/40
                "
              >
                <span className="text-slate-900 font-medium transition duration-300 group-hover:text-blue-600">
                  {stack}
                </span>
              </div>
            ))}
          </div>

        </div>
      </ScrollReveal>
    </section>
  );
}